import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function GiftNotePricesCard() {
    const [p, setP] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        api.get("/public/gift-note-prices").then(({ data }) => setP({ silver: data.silver, golden: data.golden, wrap: data.wrap })).catch(() => {});
    }, []);
    if (!p) return null;
    const save = async () => {
        setBusy(true);
        try {
            const { data } = await api.put("/partner/gift-note-prices", { silver: Number(p.silver), golden: Number(p.golden), wrap: Number(p.wrap) });
            setP(data);
            toast.success("Note prices saved");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Could not save prices");
        } finally {
            setBusy(false);
        }
    };
    const input = "w-28 bg-transparent border border-cream/30 rounded-sm px-3 py-2 text-sm text-cream";
    return (
        <div className="mt-8 p-5 border border-cream/15 rounded-sm" data-testid="gift-note-prices-card">
            <p className="text-[0.62rem] tracking-[0.3em] uppercase text-gold">Gift note prices</p>
            <div className="mt-3 flex flex-wrap gap-6 items-end text-sm text-cream">
                <label>Silver Note (up to 200 characters)
                    <div className="mt-1">$ <input type="number" step="0.01" min="0" value={p.silver} onChange={(e) => setP({ ...p, silver: e.target.value })} className={input} data-testid="gift-note-silver-input" /></div>
                </label>
                <label>Golden Note (up to 500 characters)
                    <div className="mt-1">$ <input type="number" step="0.01" min="0" value={p.golden} onChange={(e) => setP({ ...p, golden: e.target.value })} className={input} data-testid="gift-note-golden-input" /></div>
                </label>
                <label>Banana-leaf gift wrap
                    <div className="mt-1">$ <input type="number" step="0.01" min="0" value={p.wrap} onChange={(e) => setP({ ...p, wrap: e.target.value })} className={input} data-testid="gift-wrap-price-input" /></div>
                </label>
                <button onClick={save} disabled={busy} className="btn-pill btn-ghost text-[0.6rem]" data-testid="gift-note-prices-save">Save</button>
            </div>
        </div>
    );
}
